import React from 'react';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import { tasignalPDFUrl } from '../../../../configs/ContactConfig';
import { tradingTimeInterval } from '../../../helpers/Common';
import IndicatorsTable from './IndicatorsTable';
import { REDUCER_NAME, fetchIndicators, updateIndicatorPrice } from './reducer';
import MessageHub from '../../../../core/signalr/SignalrMessageHub';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';
import { ChanelConfig } from '../../../../configs/GlobalConfig';

class Indicators extends React.Component {
  componentDidMount() {
    const { listOrganizationByOrganCode, fetchIndicators } = this.props;
    if (Object.keys(listOrganizationByOrganCode).length) {
      fetchIndicators();
    }
    MessageHub.subscribe(ChanelConfig.TickChanel, this.onReceiveTicker);
    this.intervalId = tradingTimeInterval(fetchIndicators);
  }

  componentDidUpdate(prevProps) {
    const { listOrganizationByOrganCode, fetchIndicators } = this.props;
    if (
      Object.keys(listOrganizationByOrganCode).length !==
      Object.keys(prevProps.listOrganizationByOrganCode).length
    ) {
      fetchIndicators();
    }
  }

  componentWillUnmount() {
    MessageHub.unsubscribe(ChanelConfig.TickChanel, this.onReceiveTicker);
    clearInterval(this.intervalId);
  }

  onReceiveTicker = tickers => {
    const { updateIndicatorPrice, indicatorById } = this.props;
    const realtimeData = {};
    const indicators = Object.values(indicatorById);
    tickers.forEach(ticker => {
      const isExist = indicators.some(
        item => item.organCode === ticker.organCode,
      );
      if (isExist) {
        realtimeData[ticker.organCode] = ticker;
      }
    });
    if (Object.keys(realtimeData).length) {
      updateIndicatorPrice(realtimeData);
    }
  };

  render() {
    return (
      <div className="tab-pane active d-flex flex-fill flex-column h-auto mb-10">
        <IndicatorsTable />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  locale: state.i18n.locale,
  indicatorById: state[REDUCER_NAME].indicatorById,
  id: state[REDUCER_NAME].id,
  listOrganizationByOrganCode:
    state[COMMON_REDUCER_NAME].listOrganizationByOrganCode,
});

const mapDispatchToProps = {
  fetchIndicators,
  updateIndicatorPrice,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Indicators);
